let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("4T4bq"), load("KSMZE")]).then(() => parcelRequire('jFrMf'));